import React from 'react';

import { Message, Link } from 'src/core/components';

import messages from './messages';

const LINK = 'https://www.thermofisher.com/us/en/home/products-and-services/product-types/primers-oligos-nucleotides/invitrogen-custom-dna-oligos/popups/purity.html?CID=fl-configoligopurity';

const FormTitleComponent = () => (
  <Link href={LINK} target="_blank">
    <Message message={messages.moreInfo} />
  </Link>
);

export default FormTitleComponent;
